module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-reservation-requests"
  }, [_c('div', {
    staticClass: "dropdown-buttons"
  }, [_c('ModalReveal', {
    ref: _vm.modal
  }, [_c('a', {
    attrs: {
      "slot": "trigger"
    },
    on: {
      "click": _vm.search
    },
    slot: "trigger"
  }, [_vm._v("Create Booking")]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('Driver', {
    attrs: {
      "item": _vm.item.driver,
      "type": "driver-card"
    }
  })], 1), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Dates")]), _c('div', [_vm._v("From: " + _vm._s(_vm.$dateFormat(_vm.item.start, 'DD MMM YYYY HH:mm')) + " - " + _vm._s(_vm.item.pick_up.name))]), _c('div', [_vm._v("To: " + _vm._s(_vm.$dateFormat(_vm.item.end, 'DD MMM YYYY HH:mm')) + "  - " + _vm._s(_vm.item.drop_off.name))])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Passengers")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.item.flags.passengers))]), (_vm.item.flags.hasOwnProperty('luxury')) ? [_c('div', {
    staticClass: "label"
  }, [_vm._v("Luxury")]), _c('div', {
    staticClass: "value"
  }, [_c('span', {
    staticClass: "fa",
    class: {
      "fa-times": !_vm.item.flags.luxury, "fa-check": _vm.item.flags.luxury
    }
  })])] : _vm._e()], 2), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Offroad")]), _c('span', {
    staticClass: "fa",
    class: {
      "offroad": _vm.item.flags.offroad, "fa-times": !_vm.item.flags.offroad, "fa-check": _vm.item.flags.offroad
    }
  }), (_vm.item.flags.hasOwnProperty('estimated_distance')) ? [_c('label', [_vm._v("Estimated distance")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.item.flags.estimated_distance))])] : _vm._e()], 2)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Notes")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.notes))])])])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h2', [_vm._v("Select the vehicle")]), (_vm.slots.length === 0 && !_vm.loading) ? [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v("No available vehicles")])] : _vm._e(), _vm._l((_vm.slots), function(vehicle, id) {
    return (!vehicle.disabled) ? _c('vehicle', {
      key: id,
      attrs: {
        "item": vehicle,
        "type": "search-result"
      },
      on: {
        "bookVehicle": _vm.bookNow
      }
    }) : _vm._e()
  })], 2)])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c0bf0b44!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/CreateBookingFromReservationRequest.vue
// module id = 2681
// module chunks = 1